const modern_fashion = `Jotkut sanovat, että se on mautonta ja siitä puuttuu aikaisempien tyylien eleganssi.
Kriitikot korostavat keskittymistä paljastaviin vaatteisiin, mikä heidän mielestään heikentää hienostuneisuutta ja säädyllisyyttä.
Tiukat, rohkeat mallit saavat jotkut näkemään modernin muodin tärkeysarvon etusijalle hienostuneisuuden sijaan.
Kannattajat uskovat, että se juhlii yksilöllistä ilmaisua ja voimaantumista.
He näkevät sen vapautumisena normeista ja monimuotoisuuden hyväksymisestä.
Vaikka jotkut saattavat pitää sitä rohkeana, muodin pitäisi antaa ihmisten ilmaista itseään vapaasti.
Se, mikä yhdestä näyttää mauttomalta, voi olla toiselle vapauttavaa.
Muoti edustaa henkilökohtaista identiteettiä ja sen tulee sallia itseilmaisu ja vapaus.`;

export default modern_fashion;















